import * as React from 'react';

import { FallbackListingViewModel, MessagingCardViewModel } from 'src/common/models';

import { MessagingCard } from 'components/common/messaging-card';
import { ResultProps } from 'components/search/result';

export type StaticMultiItemCrossSellFallbackProps = Omit<ResultProps, 'model'> & {
  fallbackListingViewModel: FallbackListingViewModel;
};

const isMessagingCardViewModel = (model: FallbackListingViewModel | null): model is MessagingCardViewModel =>
  model && (model as MessagingCardViewModel).__typename === 'MessageResult';

export const StaticMultiItemCrossSellFallback: React.FC<StaticMultiItemCrossSellFallbackProps> = React.memo(
  ({ fallbackListingViewModel, className, analytics, ...rest }) =>
    isMessagingCardViewModel(fallbackListingViewModel) ? (
      <MessagingCard {...rest} model={fallbackListingViewModel} className={className} analytics={analytics} />
    ) : null
);
